<ion-item>
  <ion-label position="stacked">What best describes you? </ion-label>

</ion-item>

<div class="buttons-container">

  @for (item of accTypeArray; track item) {
    <span class="type-account-type tidy-button" [ngClass]="{'selected' : item.accType == accType}" tappable (click)="updateAccType(item.accType)">
      <input type="radio" name="item.accType" [attr.id]="item.accType"/>
      <label [attr.for]="item.accType">
        {{item.label}}
      </label>
    </span>
  }

</div>
